import api from '@/api/api';
import Order from '@/models/Order';

const state = {
  orders: [],
  instock_modal_asin: null,
  instock_modal_order: false,
  instock_modal_order_products: null,
  instock_modal_order_edit: null,
  loaded: false,
};

const getters = {};

const mutations = {
  set_orders: (state, payload) => {
    state.orders = payload;
  },

  set_instock_modal_asin: (state, payload) => {
    state.instock_modal_asin = payload;
  },

  set_instock_modal_order: (state, payload) => {
    state.instock_modal_order = payload;
  },

  set_instock_modal_order_products: (state, payload) => {
    state.instock_modal_order_products = payload;
  },

  set_instock_modal_order_edit: (state, payload) => {
    state.instock_modal_order_edit = payload;
  },

  set_loaded: (state, payload) => {
    state.loaded = payload;
  },
};

const actions = {

  ib_set_loaded: (context, payload) => {
    context.commit('set_loaded', payload);
  },

  ib_load_orders: (context) => {
    api().get(`${context.getters.get_app_section}/orders`)
      .then((resp) => resp.data)
      .then((data) => data.map((item) => new Order(item)))
      .then((orders) => context.commit('set_orders', orders))
      .then(() => context.commit('set_loaded', true))
      .catch((error) => {
        console.error('Error:', error);
        context.commit('set_loaded', null);
      });
  },

  ib_create_order: (context, payload) => {
    return api().post(`${context.getters.get_app_section}/orders/`, payload)
      .then(() => {
        context.dispatch('ib_load_orders');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Order created.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Order wasn\'t created. Please try again.',
        });
      });
  },

  ib_edit_order: (context, payload) => {
    const url = `${context.getters.get_app_section}/orders/${payload.order_id}`;
    return api().put(url, payload.data)
      .then(() => {
        context.dispatch('ib_load_orders');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Order created.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Order wasn\'t created. Please try again.',
        });
      });
  },

  ib_update_order: (context, payload) => api().post(`${context.getters.get_app_section}/orders/${payload.order_id}/products`, payload.data)
    .then(() => context.commit('set_instock_modal_order_products', null))
    .then(() => {
      context.dispatch('ib_load_orders');
      context.dispatch('nt_set_notification', {
        type: 'inform',
        message: 'Products were saved.',
      });
    })
    .catch((error) => {
      console.error('Error:', error);
      context.dispatch('nt_set_notification', {
        type: 'error',
        message: 'Products weren\'t save. Please try again.',
      });
    }),

  ib_delete_order: (context, payload) => {
    api().delete(`${context.getters.get_app_section}/orders/${payload}`)
      .then(() => {
        context.dispatch('ib_load_orders');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Order was deleted.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Order wasn\'t deleted. Please try again.',
        });
      });
  },

  ib_set_condition: (context, payload) => {
    api().put(`${context.getters.get_app_section}/orders/${payload.order_id}/products/set_condition`, payload.data)
      .then(() => context.commit('set_instock_modal_asin', null))
      .then(() => {
        context.dispatch('ib_load_orders');
        context.dispatch('nt_set_notification', {
          type: 'inform',
          message: 'Status was changed.',
        });
      })
      .catch((error) => {
        console.error('Error:', error);
        context.dispatch('nt_set_notification', {
          type: 'error',
          message: 'Status wasn\'t changed. Please try again.',
        });
      });
  },

};

export default {
  state,
  getters,
  mutations,
  actions,
};
